import script from "./Made.vue?vue&type=script&setup=true&lang=js"
export * from "./Made.vue?vue&type=script&setup=true&lang=js"

import "./Made.vue?vue&type=style&index=0&id=52d35f80&lang=css"

const __exports__ = script;

export default __exports__